(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('CommandProcessorStatusService', CommandProcessorStatusService);

  CommandProcessorStatusService.$inject = ['$resource'];

  function CommandProcessorStatusService ($resource) {
    return $resource(apiUrl + '/statuses/:id', { id: '@id' }, {
      getCommandProcessorStatus: { url: apiUrl + '/command-processor-statuses', method: 'GET', isArray: false },
      getCommandProcessorStatusByName: { url: apiUrl + '/command-processor-statuses-by-name', method: 'GET', isArray: false },
      getAllCommandProcessorStatusByCompany: { url: apiUrl + '/all-command-processor-statuses-by-company', method: 'GET', isArray: true },
      saveCPClassification: { url: apiUrl + '/save-cp-classification', method: 'POST', isArray: false },
      saveCPStatus: { url: apiUrl + '/save-cp-status', method: 'POST', isArray: false },
      deleteCPStatus: { url: apiUrl + '/remove-cp-status', method: 'POST', isArray: false }
    });
  }
})();
